import { useEffect, useState } from 'react'
import DetailsTag from './DetailsTag'
import Cookies from 'js-cookie';
import { getRdRentalCreditCardWithTenantIdAndIsActive } from '../../../services/GroupCreditCard';
import { getPlan } from '../../../services/Plan';
import { getRdRentalSubscriptionByTenantId } from '../../../services/Subscription';
import { Button, Dialog } from '@mui/material';
import useTenant from '../../../components/hooks/useTenant';
import colorConfigs from '../../../configs/colorConfigs';
import moment from 'moment';
import useGeneral from '../../../components/hooks/useGeneral';
import { getRdRentalACHInfoWithTenantIdAndIsActive } from '../../../services/ACHInfo';
import Loading from '../../../icons/Loading';

type SubscriptionDetailsProps = {
    setShowPopupUpgradeSubscription: (value: boolean) => void;
    planDetails: any;
    setPlanDetails: (value: any) => void;
    paymentType: number,
    setPaymentType: (value: number) => void;
    isProcessing: boolean;
    setIsProcessing: (value: boolean) => void;
    setShowPopupForPayment: (Value: boolean) => void;
    isRefreshSubscriptionDetails: boolean;
    setIsRefreshSubscriptionDetails: (value: boolean) => void;
    setActivePaymentDetails: (value: any | null) => void;
    isUpgradingTheSubcription: boolean;
    setIsUpgradingTheSubcription: (value: boolean) => void,
    callTheAPIForUpgradeSubscription: (upgradedPlan: any, paymentDetails: any, cb: any) => void;
}

const SubscriptionDetails = ({
    setShowPopupUpgradeSubscription,
    planDetails,
    setPlanDetails,
    paymentType,
    setPaymentType,
    isProcessing,
    setIsProcessing,
    setShowPopupForPayment,
    isRefreshSubscriptionDetails,
    setIsRefreshSubscriptionDetails,
    setActivePaymentDetails,
    isUpgradingTheSubcription,
    setIsUpgradingTheSubcription,
    callTheAPIForUpgradeSubscription
}: SubscriptionDetailsProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { handleTenantError }: any = useTenant();
    const { dateFormat }: any = useGeneral();
    const [subscriptionDetails, setSubscriptionDetails] = useState<any>({
        planId: "",
        status: "",
        startDate: "",
        endDate: ""
    });
    const [showPaymentDialog, setShowPaymentDialog] = useState<boolean>(false);

    useEffect(() => {
        if (tenantId && isRefreshSubscriptionDetails) {
            setIsRefreshSubscriptionDetails(false);
            getRdRentalSubscriptionByTenantId(tenantId)
                .then(res => {
                    if (res?.planId) {
                        getPlan(res?.planId)
                            .then(planRes => {
                                setPlanDetails(planRes);
                                handleTenantError(null);
                            })
                            .catch(error => {
                                handleTenantError(error);
                            });
                    }

                    setSubscriptionDetails(res);
                    handleTenantError(null);
                })
                .catch(error => {
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantId, isRefreshSubscriptionDetails])

    const upgradePlan = () => {
        setIsUpgradingTheSubcription(true);
        setShowPaymentDialog(true);
    }

    const renewPlan = () => {
        setIsUpgradingTheSubcription(false);
        setShowPaymentDialog(true);
    }

    const upgradeOrRenewThePlan = () => {
        if (tenantId) {
            if (paymentType === 0) {
                getRdRentalCreditCardWithTenantIdAndIsActive(tenantId)
                    .then(res => {                       
                        if (isUpgradingTheSubcription) {
                            setActivePaymentDetails(res);
                            setShowPopupUpgradeSubscription(true);
                            setShowPaymentDialog(false);
                        } else {
                            if (isProcessing) return;
                            setIsProcessing(true);

                            callTheAPIForUpgradeSubscription(planDetails, res, () => {
                                setShowPaymentDialog(false);
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        setActivePaymentDetails(null);
                        setShowPaymentDialog(false);

                        if (isUpgradingTheSubcription) {
                            setShowPopupUpgradeSubscription(true);
                        } else {
                            setShowPopupForPayment(true);
                        }
                    });
            } else {
                getRdRentalACHInfoWithTenantIdAndIsActive(tenantId)
                    .then(res => {
                        if (isUpgradingTheSubcription) {
                            setActivePaymentDetails(res);
                            setShowPopupUpgradeSubscription(true);
                            setShowPaymentDialog(false);
                        } else {
                            if (isProcessing) return;
                            setIsProcessing(true);

                            callTheAPIForUpgradeSubscription(planDetails, res, () => {
                                setShowPaymentDialog(false);
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        setActivePaymentDetails(null);
                        setShowPaymentDialog(false);

                        if (isUpgradingTheSubcription) {
                            setShowPopupUpgradeSubscription(true);
                        } else {
                            setShowPopupForPayment(true);
                        }
                    });
            }
        } else {
            setShowPopupUpgradeSubscription(true);
        }
    }

    return (
        <>
            <div className="w-full border border-[#167AC3] rounded-lg">
                <div className="flex justify-between items-center w-full h-[50px] px-4 py-2 bg-[#167AC3] text-white rounded-tl-lg rounded-tr-lg">
                    <h4 className="font-medium text-white">
                        Subscription Details
                    </h4>
                </div>

                <div className="flex flex-col p-4 gap-3">
                    <div className="flex gap-4">
                        <DetailsTag
                            title="Billing Plan"
                            value={`${planDetails?.planName} $${planDetails?.price ? planDetails?.price?.toFixed(2) : "0.00"}/${planDetails?.billingCycle}`}
                        />

                        <div className="w-[16.6667%]">
                            <DetailsTag
                                title="Status"
                                value={subscriptionDetails?.status}
                                bg="#4ade80"
                            />
                        </div>
                    </div>

                    <div className="flex gap-4">
                        <DetailsTag
                            title="Start Date"
                            value={moment(subscriptionDetails?.startDate)?.format(dateFormat)}
                        />

                        <DetailsTag
                            title="Next Invoice Date"
                            value={moment(subscriptionDetails?.endDate)?.format(dateFormat)}
                        />
                    </div>

                    <div className="flex gap-4">
                        <Button variant="contained"
                            sx={{
                                backgroundColor: "#167AC3"
                            }}
                            onClick={renewPlan}
                        >
                            Renew
                        </Button>

                        <Button variant="contained"
                            sx={{
                                backgroundColor: "#16a34a"
                            }}
                            onClick={upgradePlan}
                        >
                            Upgrade
                        </Button>
                    </div>

                </div>
            </div>

            <Dialog
                open={showPaymentDialog}
                onClose={() => setShowPaymentDialog(false)}
                sx={{
                    "& .MuiDialog-paper": {
                        width: "400px",
                        borderRadius: "12px",
                        padding: "20px"
                    }
                }}
            >
                <h3 className="text-lg font-semibold mb-4">
                    Select Payment Method
                </h3>

                <div className="flex flex-col gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="payment"
                            className="accent-[#167AC3] w-[16px] h-[16px]"
                            checked={paymentType === 0}
                            onChange={() => setPaymentType(0)}
                        />
                        Credit Card
                    </label>

                    <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="payment"
                            className="accent-[#167AC3] w-[16px] h-[16px]"
                            checked={paymentType === 1}
                            onChange={() => setPaymentType(1)}
                        />
                        Bank ACH
                    </label>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="button"
                        onClick={upgradeOrRenewThePlan}
                    >
                        {
                            isProcessing
                                ? <Loading />
                                : <span>Continue</span>
                        }
                    </Button>

                    <Button
                        variant="contained"
                        type="button"
                        sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => setShowPaymentDialog(false)}
                    >
                        Cancel
                    </Button>
                </div>
            </Dialog>
        </>
    )
}

export default SubscriptionDetails
